import { render, staticRenderFns } from "./NewBooking.vue?vue&type=template&id=482b6bb0"
import script from "./NewBooking.vue?vue&type=script&lang=js"
export * from "./NewBooking.vue?vue&type=script&lang=js"
import style0 from "./NewBooking.vue?vue&type=style&index=0&id=482b6bb0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports